import React, { useEffect, useState } from "react";
import { Alert, Button, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Checkbox, FormControlLabel, Box, InputAdornment, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import api from "../../../../api/api";
import Loading from "../../../../components/loading";
import { useNavigate } from "react-router-dom";

const dental_data = {
    deciduous: {
        superior: [
            { name: "CINQUENTA_E_CINCO", descricao: "55" },
            { name: "CINQUENTA_E_QUATRO", descricao: "54" },
            { name: "CINQUENTA_E_TRES", descricao: "53" },
            { name: "CINQUENTA_E_DOIS", descricao: "52" },
            { name: "CINQUENTA_E_UM", descricao: "51" },
            { name: "SESSENTA_E_UM", descricao: "61" },
            { name: "SESSENTA_E_DOIS", descricao: "62" },
            { name: "SESSENTA_E_TRES", descricao: "63" },
            { name: "SESSENTA_E_QUATRO", descricao: "64" },
            { name: "SESSENTA_E_CINCO", descricao: "65" },
        ],
        inferior: [
            { name: "OITENTA_E_CINCO", descricao: "85" },
            { name: "OITENTA_E_QUATRO", descricao: "84" },
            { name: "OITENTA_E_TRES", descricao: "83" },
            { name: "OITENTA_E_DOIS", descricao: "82" },
            { name: "OITENTA_E_UM", descricao: "81" },
            { name: "SETENTA_E_UM", descricao: "71" },
            { name: "SETENTA_E_DOIS", descricao: "72" },
            { name: "SETENTA_E_TRES", descricao: "73" },
            { name: "SETENTA_E_QUATRO", descricao: "74" },
            { name: "SETENTA_E_CINCO", descricao: "75" },
        ],
    },
    permanents: {
        superior: [
            { name: "DEZOITO", descricao: "18" },
            { name: "DEZESSETE", descricao: "17" },
            { name: "DEZESSEIS", descricao: "16" },
            { name: "QUINZE", descricao: "15" },
            { name: "QUATORZE", descricao: "14" },
            { name: "TREZE", descricao: "13" },
            { name: "DOZE", descricao: "12" },
            { name: "ONZE", descricao: "11" },
            { name: "VINTE_E_UM", descricao: "21" },
            { name: "VINTE_E_DOIS", descricao: "22" },
            { name: "VINTE_E_TRES", descricao: "23" },
            { name: "VINTE_E_QUATRO", descricao: "24" },
            { name: "VINTE_E_CINCO", descricao: "25" },
            { name: "VINTE_E_SEIS", descricao: "26" },
            { name: "VINTE_E_SETE", descricao: "27" },
            { name: "VINTE_E_OITO", descricao: "28" },
        ],
        inferior: [
            { name: "QUARENTA_E_OITO", descricao: "48" },
            { name: "QUARENTA_E_SETE", descricao: "47" },
            { name: "QUARENTA_E_SEIS", descricao: "46" },
            { name: "QUARENTA_E_CINCO", descricao: "45" },
            { name: "QUARENTA_E_QUATRO", descricao: "44" },
            { name: "QUARENTA_E_TRES", descricao: "43" },
            { name: "QUARENTA_E_DOIS", descricao: "42" },
            { name: "QUARENTA_E_UM", descricao: "41" },
            { name: "TRINTA_E_UM", descricao: "31" },
            { name: "TRINTA_E_DOIS", descricao: "32" },
            { name: "TRINTA_E_TRES", descricao: "33" },
            { name: "TRINTA_E_QUATRO", descricao: "34" },
            { name: "TRINTA_E_CINCO", descricao: "35" },
            { name: "TRINTA_E_SEIS", descricao: "36" },
            { name: "TRINTA_E_SETE", descricao: "37" },
            { name: "TRINTA_E_OITO", descricao: "38" },
        ],
    },
};

export default function ProcedureModal({ isOpen, onClose, treatment, onSaveSuccess }) {

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [description, setDescription] = useState("");
    const [observation, setObservation] = useState("");
    const [procedureValue, setProcedureValue] = useState("");
    const [dentitionType, setDentitionType] = useState('deciduous');
    const [allTeeth, setAllTeeth] = useState({ deciduous: [], permanents: [] });
    const [selectedTeeth, setSelectedTeeth] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setAllTeeth({
            deciduous: dental_data.deciduous,
            permanents: dental_data.permanents
        });
    }, []);

    useEffect(() => {
        if (!isOpen) {
            setDescription("");
            setObservation("");
            setProcedureValue("");
            setDentitionType('deciduous');
            setSelectedTeeth([]);
            setAllSelected(false);
            setError('');
        }
    }, [isOpen]);

    const changeDentitionType = (event) => {
        setDentitionType(event.target.value);
        setSelectedTeeth([]);
        setAllSelected(false);
    };

    const toggleToothSelection = (tooth) => {
        const isAlreadySelected = selectedTeeth.some(t => t.name === tooth.name);

        if (isAlreadySelected) {
            if (selectedTeeth.length > 1) {
                setSelectedTeeth(selectedTeeth.filter(t => t.name !== tooth.name));
            }
        } else {
            setSelectedTeeth([...selectedTeeth, tooth]);
        }
        setAllSelected(false);
    };

    const currentSuperiorTeeth = allTeeth[dentitionType]?.superior || [];
    const currentInferiorTeeth = allTeeth[dentitionType]?.inferior || [];
    const currentTeethList = [...currentSuperiorTeeth, ...currentInferiorTeeth];

    const toggleSelectAll = (event) => {
        const isChecked = event.target.checked;
        setAllSelected(isChecked);
        setSelectedTeeth(isChecked ? currentTeethList : []);
    };

    const validateProcedure = () => {
        if (!description || !procedureValue || selectedTeeth.length === 0) {
            setError("É obrigatório informar: Descrição, Valor e selecionar pelo menos um dente para cadastrar um procedimento");
            return false;
        }
        setError('');
        return true;
    };

    const saveProcedure = (event) => {
        event.preventDefault();

        if (!validateProcedure()) {
            return;
        }

        const procedure = {
            descricao: description,
            observacao: observation,
            dentesSelecionados: selectedTeeth,
            tratamentoId: treatment.treatmentId,
            valor: procedureValue
        };
        setLoading(true);
        api.post("/treatments/procedures", procedure, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setLoading(false);
            onSaveSuccess(returnFromApi.data);
        }).catch((returnFromApi) => {
            setLoading(false);
            console.error(returnFromApi);
            if (returnFromApi.status === 401) {
                navigate("/expired-session");
            }
        });
    };

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="lg">

            <Loading isToHidden={isLoading === false} />

            <DialogTitle>Procedimento</DialogTitle>
            <form id="new-procedure-form" onSubmit={saveProcedure}>
                <DialogContent>
                    <Collapse in={!!error}>
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    </Collapse>
                    <Grid container spacing={0.2}>

                        <Grid size={12}>
                            <FormControl fullWidth>
                                <FormLabel>Descrição:</FormLabel>
                                <TextField
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>

                        <Grid size={12}>
                            <FormControl fullWidth>
                                <FormLabel>Observação:</FormLabel>
                                <TextField
                                    value={observation}
                                    onChange={(e) => setObservation(e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>

                        <Grid size={12}>
                            <FormControl>
                                <FormLabel>Tipo:</FormLabel>
                                <RadioGroup row value={dentitionType} onChange={changeDentitionType}>
                                    <FormControlLabel value="deciduous" control={<Radio />} label="Decíduos" />
                                    <FormControlLabel value="permanents" control={<Radio />} label="Permanentes" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid>
                            <Box>
                                {currentSuperiorTeeth.map(tooth => (
                                    <FormControlLabel
                                        key={tooth.name}
                                        control={<Checkbox checked={selectedTeeth.some(t => t.name === tooth.name)} onChange={() => toggleToothSelection(tooth)} />}
                                        label={tooth.descricao}
                                    />
                                ))}
                            </Box>
                            <Box>
                                {currentInferiorTeeth.map(tooth => (
                                    <FormControlLabel
                                        key={tooth.name}
                                        control={<Checkbox checked={selectedTeeth.some(t => t.name === tooth.name)} onChange={() => toggleToothSelection(tooth)} />}
                                        label={tooth.descricao}
                                    />
                                ))}
                            </Box>
                            <Box>
                                <FormControlLabel control={<Checkbox checked={allSelected} onChange={toggleSelectAll} />} label="Todos" />
                            </Box>
                        </Grid>

                        <Grid size={12}>
                            <FormControl fullWidth>
                                <FormLabel>Valor:</FormLabel>
                                <TextField
                                    type="number"
                                    value={procedureValue}
                                    onChange={(e) => setProcedureValue(e.target.value)}
                                    fullWidth
                                    InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 1 }}>
                    <Button variant="outlined" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" type="submit" form="new-procedure-form">
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}